import * as stylex from '@stylexjs/stylex';

const styles = stylex.create({
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: -1,
        overflow: 'hidden',
        backgroundColor: '#000000',
    },
    background: {
        position: 'absolute',
        top: '-75%',
        left: '-75%',
        width: '250%',
        height: '250%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: 'brightness(0.7) contrast(1.1)',
        willChange: 'transform',
    },
    // Responsive background images
    backgroundDesktop: {
        backgroundImage: 'url(/assets/background-optimized.jpg)',
        '@media (max-width: 1280px)': {
            backgroundImage: 'url(/assets/background-medium.jpg)',
        },
        '@media (max-width: 768px)': {
            backgroundImage: 'url(/assets/background-small.jpg)',
        },
    },
});

export default function Background() {
    return (
        <div {...stylex.props(styles.container)}>
            <div {...stylex.props(styles.background, styles.backgroundDesktop)} />
        </div>
    );
} 